import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const org_reportsScreenModule = defineScreen({
  app: "coaching",
  screen_id: "org-reports",
  path: "/org/reports",
  heading: { text: "Org Reports", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "deny",
    "company_admin": "allow",
    "participant": "deny",
    "cohort_lead": "allow"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "detail.load" }
  ],
  recipe: "Detail-1",
  data: { seedNeeds: ["readonly-walk-session", "populated-list-min1"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/org-reports.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default org_reportsScreenModule;
